import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

/**
 * Create a notification in Firestore
 * @param {string} type - Type of action: 'candidate_added', 'candidate_updated', 'candidate_deleted', etc.
 * @param {string} entityType - Type of entity: 'candidate', 'instructor', 'lesson', 'payment', 'report'
 * @param {string} entityId - ID of the entity
 * @param {string} entityName - Display name of the entity (e.g., "John Doe", "Payment #123")
 * @param {object} additionalData - Additional data to include in the notification
 */
export const createNotification = async (
  type,
  entityType,
  entityId,
  entityName,
  additionalData = {}
) => {
  try {
    const notificationData = {
      type,
      entityType,
      entityId,
      entityName,
      ...additionalData,
      createdAt: serverTimestamp(),
      read: false,
    };

    await addDoc(collection(db, "notifications"), notificationData);
  } catch (error) {
    console.error("Error creating notification:", error);
    // Don't throw error - notifications are not critical
  }
};

